
    import Vue from "vue";
    import { Component, Prop } from "vue-property-decorator";

    @Component({ components: {} })
    export default class AlertDialog extends Vue {

        @Prop({ default: "Alert!" }) title!: string;
        @Prop({ default: "Something happened..." }) text!: string;
        @Prop({ default: "Okay" }) okButtonText!: string;
        @Prop({ default: "mdi-cancel" }) okButtonIcon!: string;
        @Prop({ default: false }) showCheckbox!: boolean;

        showDialog: boolean = false;

        show() {
            this.showDialog = true;
        }

        hide () {
            this.showDialog = false;
        }

        close() {
            this.$emit("closed");
            this.showDialog = false;
        }
    }
